import { useTheme } from "@emotion/react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Typography,
} from "@mui/material";
import axios from "axios";
import React, { useCallback, useEffect, useState } from "react";
import { PencilSquare, TrashFill } from "react-bootstrap-icons";
import { useSelector } from "react-redux";
import DeleteDialog from "../DeleteDialog/DeleteDialog";
import toast from "react-hot-toast";
import styles from "./paymentmethod.module.css";
import EditReason from "./Edit/EditReason";
import NewReason from "./New/NewReason";
import { arEG } from "@mui/material/locale";

const columns = [
  { id: "reason", label: "السبب", minWidth: 170 },
  { id: "actions", label: "", minWidth: 100 },
];

function DiscountReasonTable() {
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [openDialog, setOpenDialog] = useState(false);
  const [openAdd, setOpenAdd] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const theme = useTheme();

  const role = useSelector((state) => state.auth.role.roleName);

  const [data, setData] = useState([]);
  const fetchData = useCallback(async () => {
    // setLoading(true);
    try {
      const reasons = await axios.get(
        `${process.env.REACT_APP_API_URL}/discountreason/`,
        {
          withCredentials: true,
        }
      );
      setData(reasons.data);
      // console.log(reasons);

      // setLoading(false);
    } catch (error) {
      // setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const handleCloseNewForm = () => setOpenAdd(false);
  const handleCloseEditForm = () => setOpenEdit(false);
  const handleCloseDialog = () => setOpenDialog(false);

  const handleEditClick = (row) => {
    setSelectedRow(row);
    setOpenEdit(true);
  };
  const handleDeleteClick = (id) => {
    setDeleteId(id); // Set the id of the record to be deleted
    setOpenDialog(true); // Open the dialog
  };

  const handleDelete = async () => {
    if (deleteId) {
      try {
        const res = await axios.delete(
          `${process.env.REACT_APP_API_URL}/discountreason/${deleteId}`,
          {
            withCredentials: true,
          }
        );
        if (res) {
          toast.success("تم حذف سبب الخصم بنجاح!");
          setData((prevData) =>
            prevData.filter((item) => item.id !== deleteId)
          );
          setDeleteId(null);
        }
      } catch (error) {
        toast.error(error.message);
        setDeleteId(null);
      }
    }
    setOpenDialog(false);
  };
  const handleAddClick = () => {
    setOpenAdd(true);
  };

  return (
    <div className={styles.section}>
      <DeleteDialog
        handleCloseDialog={handleCloseDialog}
        open={openDialog}
        message={"هل أنت متأكد من أنك تريد حذف"}
        handleDelete={handleDelete}
      />
      <NewReason
        open={openAdd}
        triggerFetch={fetchData}
        closeDialog={handleCloseNewForm}
      />
      <EditReason
        open={openEdit}
        triggerFetch={fetchData}
        closeDialog={handleCloseEditForm}
        row={selectedRow}
      />
      <div className={styles.sectionHeading}>
        <div className="text">
          <Typography
            variant="h6"
            fontWeight={600}
            color={theme.palette.neutral[800]}
          >
            أسباب الخصم
          </Typography>
          <Typography variant="body2" color={theme.palette.neutral[600]}>
            قم بإدارة أسباب الخصم المتاحة.
          </Typography>
        </div>
        <Button
          variant="contained"
          sx={{
            backgroundColor: theme.palette.primary[50],
            color: theme.palette.primary[600],
            border: `${theme.palette.primary[600]} 1px solid`,
          }}
          disableElevation={true}
          onClick={handleAddClick}
        >
          إضافة سبب جديد
        </Button>
      </div>
      <div className={styles.table}>
        <TableContainer sx={{ maxHeight: 440 }}>
          <Table stickyHeader aria-label="viewtypes table">
            <TableHead>
              <TableRow>
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={columns.length} align="center">
                    لا يوجد بيانات
                  </TableCell>
                </TableRow>
              ) : (
                data
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row) => (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell key={column.id} align={column.align}>
                            {column.id === "actions" ? (
                              <Box
                                sx={{
                                  width: "100%",
                                  height: "100%",
                                  display: "flex",
                                  justifyContent: "space-evenly",
                                  alignItems: "center",
                                }}
                              >
                                {role === "SuperAdmin" && (
                                  <Button
                                    variant="contained"
                                    sx={{
                                      width: "36px",
                                      height: "36px",
                                      padding: 0,
                                      margin: 0,
                                      minWidth: "auto",
                                      backgroundColor:
                                        theme.palette.neutral[50],
                                      "&:hover": {
                                        backgroundColor:
                                          theme.palette.neutral[100],
                                      },
                                    }}
                                    onClick={() => handleEditClick(row)}
                                    disableElevation
                                  >
                                    <PencilSquare
                                      size={16}
                                      color={theme.palette.primary[600]}
                                    />
                                  </Button>
                                )}
                                {role === "SuperAdmin" && (
                                  <Button
                                    variant="contained"
                                    sx={{
                                      width: "36px",
                                      height: "36px",
                                      padding: 0,
                                      margin: 0,
                                      minWidth: "auto",
                                      backgroundColor:
                                        theme.palette.neutral[50],
                                      "&:hover": {
                                        backgroundColor:
                                          theme.palette.neutral[100],
                                      },
                                    }}
                                    onClick={() => handleDeleteClick(row.id)}
                                    disableElevation
                                  >
                                    <TrashFill
                                      size={16}
                                      color={theme.palette.primary[600]}
                                    />
                                  </Button>
                                )}
                              </Box>
                            ) : (
                              value
                            )}
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          rowsPerPageOptions={[10, 25, 100]}
          component="div"
          count={data.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          labelRowsPerPage={
            arEG.components.MuiTablePagination.defaultProps.labelRowsPerPage
          }
          labelDisplayedRows={
            arEG.components.MuiTablePagination.defaultProps.labelDisplayedRows
          }
        />
      </div>
    </div>
  );
}

export default DiscountReasonTable;
